export default "__VITE_ASSET__32e536f9__"